import { Alert, FormGroup, FormParagraph, FormSection } from '@ksyos/design-system';
import type { IServiceOrganizationSettingFormSectionProps } from '../ServiceOrganizationSetting';
import { ServiceType } from '../../../../../../common/enums/serviceType';
import { translateKey } from '../../../../../translate';
import { InputTriState } from '../../../../elements/common';
import { ServiceOrganizationSettingFormMode } from '../ServiceOrganizationSetting';

interface IRequestRecipientFormSectionProps extends IServiceOrganizationSettingFormSectionProps {
    hasRequestRecipientProviders: boolean;
    isRecipientIsOwnOrganization: boolean;
}

export function RequestRecipientFormSection(props: IRequestRecipientFormSectionProps) {
    if (
        ![ServiceType.examination, ServiceType.consultation, ServiceType.referral, ServiceType.referralSmall].includes(
            props.service.serviceType
        ) ||
        !props.hasServiceProviders
    ) {
        return null;
    }

    return (
        <FormSection title={translateKey('serviceOrganizationSetting.requestRecipientTitle')}>
            {!props.isRecipientIsOwnOrganization &&
                !props.isRequestRecipient &&
                !props.hasRequestRecipientProviders &&
                props.mode === ServiceOrganizationSettingFormMode.edit && (
                    <Alert appearance="info">{translateKey('serviceProvider.messageNoServiceProviderRecipient')}</Alert>
                )}

            <FormGroup label={translateKey('serviceOrganizationSetting.isRequestRecipient')}>
                {props.mode === ServiceOrganizationSettingFormMode.read ? (
                    <FormParagraph>
                        {props.isRequestRecipient ? translateKey('common.yes') : translateKey('common.no')}
                    </FormParagraph>
                ) : (
                    <InputTriState
                        fieldKey="isRequestRecipient"
                        notNullable
                    />
                )}
            </FormGroup>
        </FormSection>
    );
}
